export default function ($translate) {
    return {
        KEYS: {
            ALL_COURSE_TARGETS: 'ALL_COURSE_TARGETS',
            CUSTOM_TARGETS: 'CUSTOM_TARGETS'
        },
        LABELS: {
            ALL_COURSE_TARGETS: $translate.instant('planningGroup.Course all targets'),
            CUSTOM_TARGETS: $translate.instant('planningGroup.Custom selection of targets')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/automated/planning/group/targetType/index.js